/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {Component, Input, ViewEncapsulation, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {FcResponsiveAgGridService} from './fc-responsive-ag-grid.service';
import {FcResponsiveAgGridOptions} from './fc-responsive-ag-grid-options';

/**
 * Grid component with Angular.
 */
@Component({
    selector: 'fc-responsive-ag-grid-paging',
    templateUrl: './fc-responsive-ag-grid-paging.component.html',
    styleUrls: ['./fc-responsive-ag-grid-paging.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcResponsiveAgGridPagingComponent implements OnInit {

    /**
     * Fc Responsive Ag Grid Options.
     */
    @Input() gridOptions: FcResponsiveAgGridOptions;

    /**
     * Default constructor.
     *
     * @param fcResponsiveAgGridService FcResponsiveAgGridService.
     */
    constructor(private fcResponsiveAgGridService: FcResponsiveAgGridService) {}

    /**
     * Angular life cycle.
     */
    ngOnInit() {
        this.gridOptions.isDropDownOpen = false;
        this.gridOptions.getPageNumbers = (): Array<number> => {
            let numberOfPage = 0;
            if (this.gridOptions && this.gridOptions.dataLength && this.gridOptions.gridState &&
                this.gridOptions.gridState.pageSize) {
                numberOfPage = Math.ceil(this.gridOptions.dataLength / this.gridOptions.gridState.pageSize);
            }
            return _.range(1, numberOfPage + 1);
        };

        this.gridOptions.showPage = (currentPage: number) => {
            if (this.gridOptions.gridState) {
                this.gridOptions.gridState.currentPage = currentPage;
            }
            this.updateTableData();
        };

        this.gridOptions.pageSizeChange = (currentPageSize: number) => {
            if (this.gridOptions.gridState) {
                this.gridOptions.gridState.currentPage = 1;
                this.gridOptions.gridState.pageSize = currentPageSize;
            }
            this.updateTableData();
        };

        this.gridOptions.getPageDetail = (): string => {
            if (!this.gridOptions || !this.gridOptions.gridState || !this.gridOptions.dataLength ||
                !this.gridOptions.gridState.currentPage || !this.gridOptions.gridState.pageSize) {
                return '';
            }

            let fromPage: number =
                ((this.gridOptions.gridState.currentPage - 1) * this.gridOptions.gridState.pageSize) + 1;
            let toPage: number =
                this.gridOptions.gridState.currentPage * this.gridOptions.gridState.pageSize;

            if (toPage > this.gridOptions.dataLength) {
                toPage = this.gridOptions.dataLength;
            }

            return `${fromPage} - ${toPage} of ${this.gridOptions.dataLength}`;
        };
    }

    /**
     * Update table data when changing page, page size.
     */
    updateTableData() {
        if (this.gridOptions.serverPagination) {
            if (this.gridOptions.setGridData) {
                this.gridOptions.setGridData();
            }
        } else {
            if (this.gridOptions.allData) {
                this.gridOptions.data = this.fcResponsiveAgGridService
                    .pagingUISide(this.gridOptions.allData, this.gridOptions).data;
                this.gridOptions.dataLength = this.fcResponsiveAgGridService
                    .pagingUISide(this.gridOptions.allData, this.gridOptions).dataLength;
                if (this.gridOptions.selectedList) {
                    this.gridOptions.selectedList = (this.gridOptions.data || []).filter(item => item.selected);
                }
            }
        }
    }
}